import * as React from 'react';
import { Loader } from '@progress/kendo-react-indicators';
import '@progress/kendo-theme-default/dist/all.css';
import './index.scss';
export default function Loading() {
    return (
        <div className='tennis-loader-container'>
            <Loader type="converging-spinner" size="large" />
        </div>
    );
}